<template>
  <div>
    <md-menu md-size="huge" v-if="user">
      <md-avatar md-menu-trigger class="md-avatar-icon md-primary">
        <img :src="user.photo" alt="Avatar" v-if="user.photo">
        <md-ripple
          class="s1-U__text-uppercase"
          v-else
        >{{user.name.charAt(0) || user.nickname.charAt(0)}}</md-ripple>
        <md-tooltip class="md-xsmall-hide md-small-hide" md-direction="left">{{ $t('account_options') }}</md-tooltip>
      </md-avatar>

      <md-menu-content>
        <md-menu-item
          class="s1-U__bg-color--body-bg s1-U__pd--tp16 s1-U__pd--bt16 s1-U__mg--bt8"
          style="margin-top: -8px;"
        >
          <s1vm-user-summary></s1vm-user-summary>
        </md-menu-item>

        <md-menu-item @click="redirect(profileUrl)">
          <span>{{ $t('my_informations') }}</span>
        </md-menu-item>

        <md-menu-item @click="redirect(logoutUrl)">
          <span>{{ $t('do_logout') }}</span>
        </md-menu-item>
      </md-menu-content>
    </md-menu>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('user', {
      user: 'INFO',
      profileUrl: 'PROFILE_URL',
      logoutUrl: 'LOGOUT_URL'
    })
  },
  methods: {
    redirect(url) {
      window.location.href = url;
    }
  }
}
</script>
